// themeActions.js
export const SET_THEME = 'SET_THEME';

export const setTheme = (theme) => async(dispatch) => {
    dispatch({type: SET_THEME, data: theme})
}